import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";
import { AppContext } from "../../contexts/AppContext";
import SubHeader from "../../components/SubHeader/SubHeader";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import "../../styles/globals.css";
import "./ReservationDonePage.css";

/**
 * 予約完了画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function ReservationDonePage() {
  const {
    globalMedicalInstitutionName,
    globalLoginUserInfo,
    globalQuestionnaireToken,
    globalMedicalInstitutionId,
    globalLoading,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const [visibleMedicalSurveyEntry, setVisibleMedicalSurveyEntry] =
    useState(true);
  const [visibleAccountEntry, setVisibleAccountEntry] = useState(true);
  const [agreementChecked, setAgreementChecked] = useState(false);

  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {
    // データ読込処理
    const loadDatas = async () => {
      window.scrollTo(0, 0);
      // 問診IDが存在した場合、問診記入エリアを表示
      setVisibleMedicalSurveyEntry(globalQuestionnaireToken !== null);

      if (globalLoginUserInfo) {
        setVisibleAccountEntry(false);
      } else {
        // 未ログインの場合、アカウント登録を促す
        setVisibleAccountEntry(true);
      }
    };

    if (!globalLoading) {
      loadDatas();
    }
  }, [globalLoading]);

  /**
   * 問診記入ボタンクリック時
   * @param {} なし
   * @return {}  なし
   */
  const handleMedicalSurveyEntryClick = () => {
    // 問診記入画面に遷移
    navigate(
      `/questionnaire-entry?token=${globalQuestionnaireToken}#medicalInstitutionId=${globalMedicalInstitutionId}`
    );
  };

  /**
   * メールアドレスで登録ボタンクリック時
   * @param {} なし
   * @return {}  なし
   */
  const handleAccountLoginEntryClick = () => {
    // アカウント登録画面に遷移
    navigate(`/account-regist`);
  };

  /**
   * 同意チェックボックス変更時の処理
   * @param {object} e - イベントオブジェクト
   */
  const handleAgreementChange = (e) => {
    setAgreementChecked(e.target.checked);
  };

  return (
    <div className="reservation-done">
      <SubHeader clinicName={globalMedicalInstitutionName} />
      <div className="main-area">
        <div className="done-message-area">
          <CheckCircleOutlined className="done-message-icon" />
          <div className="done-message-label">予約が完了いたしました</div>
        </div>
        {visibleMedicalSurveyEntry && (
          <div className="questionnaire-entry-button-area">
            <div className="done-message-detail">
              続いて問診を記入してください
            </div>
            <GeneralButton
              buttonLabel={"問診記入"}
              type={"primary-blue"}
              onClick={() => handleMedicalSurveyEntryClick()}
            />
          </div>
        )}
        <div className="done-message-detail">
          予約内容をご登録のメールアドレスに送信しました。
          <br />
          予約した日時に当院までお越しください。
        </div>
        {visibleAccountEntry && (
          <>
            <div className="account-entry-button-area">
              <span className="label1">次回以降に簡単予約</span>
              <br />
              <span className="label2">ウィーメックスアカウントを作成</span>
              <br />
              <div className="account-entry-detail">
                ウィーメックスアカウントにご登録いただくと、次回以降に簡単に予約を行うことができます。
                <br />
                ウィーメックスアカウントの登録には、
                <a
                  href={process.env.REACT_APP_WEMEX_ACCOUNT_TERMS_OF_USE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ウィーメックスアカウント利用規約
                </a>
                に同意いただく必要があります。ウィーメックスアカウントへの登録を希望しない場合は、
                {visibleMedicalSurveyEntry
                  ? "上記問診記入から問診入力に進んでください。"
                  : "画面を閉じてください。"}
              </div>
              <div className="agreement">
                <Checkbox onChange={handleAgreementChange}>
                  ウィーメックスアカウントの規約に同意する
                </Checkbox>
              </div>
              <GeneralButton
                buttonLabel={"メールアドレスで登録"}
                type={!agreementChecked ? "disabled" : "primary-blue"}
                onClick={() => handleAccountLoginEntryClick()}
              />
            </div>
            {visibleMedicalSurveyEntry && (
              <div className="label3">
                ※アカウント登録後、登録されたメールにて問診の回答をお願いします。
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ReservationDonePage;
